// extracted by mini-css-extract-plugin
export default {"outerDiv":"OfferTrackUtil_outerDiv__g1hC7","txtB":"OfferTrackUtil_txtB__KsB03","txt":"OfferTrackUtil_txt__LZQUi"};